import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/prd-products/my-account/{uuid}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetMyAccountProductDetailInput = paths[url]['get']['parameters']['path'];
export type GetMyAccountProductDetailSuccessResponse = paths[url]['get']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get a user's product.
 */
export const useGetMyAccountProductDetail = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setMyAccountProductDetail, setIsLoadingMyAccountProductDetail } = useData();

    const request = async (props: GetMyAccountProductDetailInput) => {
        setIsLoadingMyAccountProductDetail(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{uuid}', props.uuid || '')}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const error = new Error() as ApiError;

                try {
                    const json = await response.json();
                    error.message = json.message;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error: any) {
                    error.message = '';
                }

                error.statusCode = response.status;

                throw error;
            }

            const data: GetMyAccountProductDetailSuccessResponse = await response.json();

            setMyAccountProductDetail(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
        } finally {
            setIsLoadingMyAccountProductDetail(false);
        }
    };

    return { request };
};
